exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".step-test-phone .form-group[data-v-93805a50] {\n  margin-top: 80px;\n}\n.step-test-phone .action-buttons[data-v-93805a50] {\n  display: flex;\n  gap: 12px;\n  justify-content: stretch;\n}\n.step-test-phone .action-buttons button[data-v-93805a50] {\n  flex: 1;\n  justify-content: center;\n}\n", ""]);

// exports
